import { Controller } from '@hotwired/stimulus';

export default class extends Controller {
  static targets = ['trigger', 'target']

  connect() {
    this.toggle();
  }

  toggle() {
    const isChecked = this.triggerTargets.some((checkbox) => checkbox.checked);
    const targets = this.targetTargets;

    targets.forEach((target) => {
      target.disabled = !isChecked;

      if (!isChecked) {
        target.classList.add('disabled');
        target.checked = false;
      } else {
        target.classList.remove('disabled');
      }
    });
  }
}
